module.exports = __webpack_public_path__ + "img/hr-splitter-east.326bc309.png";